import { makeStyles } from "@material-ui/core"

import { colors } from "@/styles/colors"
import ColorUtil from "@/utils/ColorUtil"

const useStyles = makeStyles(({
	scriptLetalkChip: {
		background: colors.blue[100],
		color: colors.blue[900]
	},
	scriptLetalkChipIcon: {
		marginLeft: 8,
		width: 14
	},
	videoContainer: {
		display: "flex",
		justifyContent: "center",
		alignItems: "center",
		position: "relative",
		width: "100%",
		height: "100%",
		overflow: "hidden",
		border: `1px solid ${colors.gray[100]}`,
		borderRadius: 8,
		"&:hover $videoPlayer": {
			...ColorUtil.getBackgroundAndContrastColor(colors.purple[600]),
			transform: "translate(-50%, -50%) scale(0.9)",
			transition: "transform 0.1s linear, background-color 0.1s linear"
		}
	},
	videoThumbnailImg: {
		width: "100%",
		height: "100%",
		objectFit: "cover"
	},
	videoPlayer: {
		width: 64,
		height: 64,
		borderRadius: 999,
		...ColorUtil.getBackgroundAndContrastColor(colors.purple[500]),
		position: "absolute",
		top: "50%",
		left: "50%",
		transform: "translate(-50%, -50%) scale(1)",
		display: "flex",
		justifyContent: "center",
		alignItems: "center",
		transition: "transform 0.1s linear, background-color 0.1s linear"
	},
	videoPlayerIcon: {
		color: "white",
		fontSize: 42
	},
	title: {
		fontWeight: 500,
		fontSize: 20,
		lineHeight: "24px",
		color: colors.gray[700]
	},
	description: {
		fontSize: 16,
		lineHeight: "24px",
		color: colors.gray[600],
		margin: "8px 0"
	},
	button: {
		width: "fit-content",
		background: colors.gray[50],
		color: colors.gray[800],
		fontWeight: 500,
		boxShadow: "none",
		marginTop: 16,
		"&:hover": {
			background: colors.gray[100],
			color: colors.gray[700],
			boxShadow: "none"
		}
	},
	buttonIcon: {
		color: colors.purple[500],
		fontSize: 16
	}
}))

export default useStyles
